import { URLS } from '@/constants';

import { apiSession } from '../session';
import { SystemNotification } from './models/systemNotifications';

/**
 * This service utilizes an endpoint which is a wrapper around the Django Messages framework. It is used to display system notifications to the user.
 *
 * Docs: https://docs.djangoproject.com/en/5.1/ref/contrib/messages/
 */
export async function getSystemNotifications() {
  const response = await apiSession.get<SystemNotification[]>(URLS.SYSTEM_NOTIFICATIONS.LIST);

  return response.data;
}
